/**
 * @flow
 * @relayHash 50a9e1de6b2190707891d568bb955d09
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GameDetailsGetGameByTypeQueryVariables = {|
  game_type_id: string,
  name: string,
|};
export type GameDetailsGetGameByTypeQueryResponse = {|
  +findGameByTypeName: ?{|
    +data: ?$ReadOnlyArray<?{|
      +_id: ?string,
      +name: ?string,
      +created_at: ?any,
    |}>
  |}
|};
export type GameDetailsGetGameByTypeQuery = {|
  variables: GameDetailsGetGameByTypeQueryVariables,
  response: GameDetailsGetGameByTypeQueryResponse,
|};
*/


/*
query GameDetailsGetGameByTypeQuery(
  $game_type_id: ID!
  $name: String!
) {
  findGameByTypeName(name: $name, game_type_id: $game_type_id) {
    data {
      _id
      name
      created_at
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "game_type_id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "name",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "findGameByTypeName",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "game_type_id",
        "variableName": "game_type_id"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "concreteType": "games",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "data",
        "storageKey": null,
        "args": null,
        "concreteType": "gamedata",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "created_at",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GameDetailsGetGameByTypeQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "GameDetailsGetGameByTypeQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "GameDetailsGetGameByTypeQuery",
    "id": null,
    "text": "query GameDetailsGetGameByTypeQuery(\n  $game_type_id: ID!\n  $name: String!\n) {\n  findGameByTypeName(name: $name, game_type_id: $game_type_id) {\n    data {\n      _id\n      name\n      created_at\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0acb1b6280f483e62a8db2dae0fd3633';
module.exports = node;
